import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Auth } from '../../../services/auth';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class Header implements OnInit, OnDestroy {
  private auth = inject(Auth);
  private router = inject(Router);
  private destroy$ = new Subject<void>();
  
  user = this.auth.user;
  pageTitle = signal('Dashboard');

  ngOnInit() {
    // Update page title based on route
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        const route = event.urlAfterRedirects;
        const titleMap: Record<string, string> = {
          '/dashboard': 'Dashboard',
          '/orders': 'Orders',
          '/menu': 'Menu Items',
          '/broadcast': 'Broadcast',
          '/inventory': 'Inventory',
          '/purchase-orders': 'Purchase Orders',
          '/vendors': 'Vendor Management',
          '/recipes': 'Recipe Cards',
          '/reports': 'Reports & Analytics',
          '/users': 'User Management',
          '/settings': 'Settings'
        };
        this.pageTitle.set(titleMap[route] || 'Dashboard');
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    if (confirm('Are you sure you want to logout?')) {
      this.auth.logout();
    }
  }

  getUserInitial(): string {
    const user = this.user();
    if (user?.name) {
      return user.name[0].toUpperCase();
    }
    return 'A';
  }
}
